//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import switchButtons from "@/components/switchButtons";
import mapAuth from "@/components/mapAuth";
import tags from "~/components/tags";
export default {
  name: "informAuth",
  comments: {
    tags,
    mapAuth,
    switchButtons
  },
}
